import React, { useEffect, useState } from "react";
import { useStaticQuery, graphql } from "gatsby"


import PopularSearchItem from "./Sections/PopularSearchItem";

const PopularSearchSection = (props) => {
    const [search, setSearch] = useState(false);

    const openPopular = () => {
        setSearch(!search);
    };

    const staticData = useStaticQuery(graphql`
    query MyQueryPopularSearch {
      glstrapi {
          allMenus {
            Primary_URL
            Label
            popular_searches {
              id
              Name
              Content
            }
            Modules {
              ... on GLSTRAPI_ComponentComponentPopularSearchComponent {
                id
                Popular_Search_Module {
                  popular_search {
                    Content
                    Name
                  }
                }
              }
            }
          }
        }
      }
  `)
    const allMenus = staticData?.glstrapi?.allMenus || [];
    const filteredMenus = allMenus.filter(m => m.Primary_URL === props.slug);
    const data = { allMenus: filteredMenus };
    return (

      <div className={search ? "menu-wrapper popular active" : "menu-wrapper popular"}>
        <h5 onClick={openPopular}>
        Popular Searches
        <a href="javascript:;">
            <i className={search ? "icon-minus" : "icon-plus"}></i>
        </a>
        </h5>
        
        <PopularSearchItem data={data?.allMenus && data?.allMenus?.length > 0 ? data?.allMenus[0] : ""} />
    </div>

    );
};
export default PopularSearchSection;